import React, { useCallback, useContext } from 'react'
import { connect } from 'react-redux'
import TextButton from 'LuxKit/Button/TextButton'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import NavigationHeaderTripsMenu from './NavigationHeaderTripsMenu'
import Group from 'components/utils/Group'
import BusinessTravellerAccountButtonMenu from 'businessTraveller/components/business-account/BusinessTravellerAccountButtonMenu'
import config from 'constants/config'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import ModalContext from 'contexts/ModalContext'
import MyCartMenu from './MyCartMenu'
import AddToCartModal from 'components/Common/Modals/AddToCartModal/AddToCartModal'
import HeaderNotification from '../HeaderNotification'
import { isMultiCartEnabled } from 'selectors/featuresSelectors'

interface Props {
  isLoggedIn: boolean;
  className?: string;
  isMultiItemCart: boolean;
}

function NavigationHeader(props: Props) {
  const {
    isLoggedIn,
    className,
  } = props

  const showModal = useContext(ModalContext)
  const showLogin = useCallback(() => {
    showModal(<AccountAccessModal />)
  }, [showModal])

  return (
    <Group direction="horizontal" gap={8} className={className}>
      <TripGuard>
        <NavigationHeaderTripsMenu />
      </TripGuard>
      {isLoggedIn && <>
        {config.UNIVERSAL_CHECKOUT_MULTI_CART_ITEMS_ENABLED && <>
          <MyCartMenu />
          <AddToCartModal />
        </>}
        <BusinessTravellerAccountButtonMenu />
        {config.NOTIFICATION_CENTRE_ENABLED && <HeaderNotification />}
      </>}

      {!isLoggedIn && (
        <TextButton
          kind="primary"
          onClick={showLogin}
          role="menuitem"
          name="signup"
        >
          Log in
        </TextButton>
      )}
    </Group>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isMultiItemCart: isMultiCartEnabled(state),
  }
}

export default connect(mapStateToProps)(NavigationHeader)
